import ContactInfo from 'src/models/contactInfo.js';
import Address from 'src/models/address.js';
import Role from 'src/models/role.js';
import CollectivityLabel from 'src/models/collectivityLabel.js';
import i18n from 'src/i18n/index.js';

class User {
  constructor(params) {
    if (!params) return undefined;

    this.customerNumber = params.CustomerNumber;
    this.accountId = params.AccountId;
    this.emailAddress = params.EmailAddress;
    this.firstName = params.FirstName;
    this.lastName = params.LastName;
    this.birthDate = params.BirthDate;
    this.prefix = params.Prefix;
    this.maidenName = params.MaidenName;
    this.prefixMaidenName = params.PrefixMaidenName;
    this.initials = params.Initials;
    this.gender = params.Gender;
    this.shouldResetPassword = params.ShouldResetPassword;
    this.shouldProvideEmailAddress = params.ShouldProvideEmailAddress;
    this.shouldVerifyEmailAddress = params.ShouldVerifyEmailAddress;
    this.signedTermsOfAgreement = params.SignedTermsOfAgreement;
    this.isDefaulter = params.IsDefaulter;
    this.shouldShowDigitalPopup = params.ShouldShowDigitalPopUp;

    this.collectivityLabel = new CollectivityLabel(params.CollectivityLabel);
    this.role = new Role(params.Role);

    const lastNameWithPrefix = this.prefix ? `${this.prefix} ${this.lastName}` : `${this.lastName}`;
    const maidenNameWithPrefix = this.prefixMaidenName
      ? `${this.prefixMaidenName} ${this.maidenName}`
      : `${this.maidenName}`;
    this.fullLastName = this.maidenName ? `${lastNameWithPrefix} - ${maidenNameWithPrefix}` : `${lastNameWithPrefix}`;

    this.fullNameWithSalutation = `${i18n.global.t(`gender.salutation-${params.Gender.toLowerCase()}`)} ${this.initials} ${this.fullLastName}`;
    this.address = undefined;
    this.contactInfo = undefined;
    return this;
  }

  addAddress(params) {
    this.address = new Address(params);

    return this;
  }

  addContactInfo(params) {
    this.contactInfo = new ContactInfo(params);
    return this;
  }

  updateEmailAddress(emailAddress) {
    this.emailAddress = emailAddress;
    return this;
  }
}

export { User as default };
